import React from 'react';

const EventManagerSVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { ...props } ) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid meet"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={4}
      {...props}
    >
      <g
        transform="translate(0,100) scale(0.1,-0.1)"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={20}
      >
        <path d="M20 880 c-19 -19 -20 -33 -20 -380 0 -347 1 -361 20 -380 19 -19 33
-20 480 -20 447 0 461 1 480 20 19 19 20 33 20 380 0 347 -1 361 -20 380 -19
19 -33 20 -480 20 -447 0 -461 -1 -480 -20z m935 -380 l0 -355 -455 0 -455 0
-3 345 c-1 190 0 351 3 358 3 10 99 12 457 10 l453 -3 0 -355z"/>
        <path d="M262 720 c-89 -44 -162 -83 -162 -88 0 -15 119 -260 129 -267 6 -3
45 10 87 30 42 19 78 35 80 35 2 0 5 -46 6 -102 l3 -103 235 0 235 0 0 185 0
185 -165 3 -165 3 -47 100 c-26 54 -53 99 -60 98 -7 0 -86 -36 -176 -79z m203
-40 c19 -38 35 -72 35 -74 0 -3 -21 -6 -47 -8 l-48 -3 -3 -58 -3 -58 -75 -36
c-41 -20 -76 -34 -78 -32 -5 5 -96 201 -96 206 0 4 261 131 272 132 4 1 24
-30 43 -69z m375 -270 l0 -150 -200 0 -200 0 0 150 0 150 200 0 200 0 0 -150z"/>
        <path d="M301 650 c-16 -9 -6 -30 15 -30 15 0 20 25 6 34 -4 2 -14 1 -21 -4z"/>
        <path d="M624 509 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16
-11z"/>
      </g>
    </svg>
  );
};

export { EventManagerSVG };